<script setup>
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline'

const quicklinks = [
  [
    {
      name: 'Available certificates',
      url: '/#available-certificates'
    },
    {
      name: 'Cast your vote',
      url: '/#cast-your-vote'
    },
    {
      name: 'Hire developers',
      url: '/#hire-developers'
    }
  ],
  [
    {
      name: 'Contact us',
      url: 'mailto:team@certificates.dev'
    },
    {
      name: 'Terms and conditions',
      target: '_blank',
      url: '/legal/cert-terms-conditions'
    },
    {
      name: 'Privacy policy',
      target: '_blank',
      url: '/legal/cert-privacy-policy'
    },
    {
      name: 'Help Center',
      target: '_blank',
      url: 'https://support.certificates.dev'
    },
    {
      name: 'Blog',
      url: '/blog'
    }
  ]
]

const socials = [
  {
    name: 'x',
    url: 'https://twitter.com/CertificatesDev'
  },
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/company/certificates-dev/'
  },
  {
    name: 'facebook',
    url: 'https://www.facebook.com/certificates.dev'
  },
  {
    name: 'youtube',
    url: 'https://www.youtube.com/@certificatesdev'
  },
  {
    name: 'bluesky',
    url: 'https://bsky.app/profile/certificates.dev'
  }
]
</script>

<template>
  <footer class="bg-eerie-black">
    <AppContainer
      class="py-15 md:py-20">
      <!-- <div
        class="flex w-full items-center md:justify-center xl:justify-between">
        <img
          src="/images/homepage/logo-certificates-footer.svg"
          alt="Logo"
          title="Home"
          class="dark h-10 w-auto">
      </div> -->
      <div
        class="dark mx-auto flex max-w-xl flex-col items-start gap-10 md:items-center md:gap-15 xl:max-w-full xl:flex-row xl:items-start xl:gap-28">
        <div
          class="dark flex flex-col text-center md:text-left xl:w-152 xl:shrink-0">
          <h3 class="text-left text-base font-bold text-body-text md:text-center md:text-3xl xl:text-left">
            Earn certifications that will <span class="heading-primary"><em>validate your skills and knowledge</em></span>, demonstrate your commitment, and enhance your job prospects and career advancement.
          </h3>
          <div
            class="mt-10 flex flex-col items-center md:mt-15 xl:items-start">
            <p
              class="font-light text-body-gray">
              Reach out on Social Media
            </p>
            <div
              class="mt-5 flex w-full justify-center gap-8 md:w-fit md:gap-5 xl:justify-start">
              <a
                v-for="(social, index) in socials"
                :key="index"
                target="_blank"
                class="group rounded-full bg-body-gray/20 p-3 hover:bg-gradient-to-b hover:from-dodger-shine hover:to-azure-radiance"
                :href="social.url">
                <InlineSvg
                  hard-code
                  :src="`/images/socials-${social.name}.svg`"
                  class="size-8 fill-current text-body-gray group-hover:text-white"
                  :alt="social.name" />
              </a>
            </div>
          </div>
        </div>
        <div
          class="flex flex-1 justify-start gap-10 md:gap-40">
          <ul
            v-for="(group,index) in quicklinks"
            :key="index"
            class="inline-block w-fit space-y-5 px-4 text-xl font-light md:px-0">
            <li
              v-for="link in group"
              :key="link.name"
              class="w-fit">
              <a
                v-if="link.url.includes('mailto:')"
                class="text-base text-eerie-black hover:text-azure-radiance disabled:cursor-not-allowed disabled:opacity-75 dark:text-body-gray dark:hover:text-dodger-shine"
                :href="link.url">
                {{ link.name }}
              </a>
              <NuxtLink
                v-else
                class="flex items-center text-base text-eerie-black hover:text-azure-radiance disabled:cursor-not-allowed disabled:opacity-75 dark:text-body-gray dark:hover:text-dodger-shine"
                type="button"
                :to="link.url"
                :target="link.target">
                {{ link.name }}
                <ArrowTopRightOnSquareIcon
                  v-if="link.target === '_blank'"
                  class="ml-2 w-4" />
              </NuxtLink>
            </li>
          </ul>
        </div>
      </div>
    </AppContainer>
    <div
      class="w-full bg-gradient-to-r from-dodger-shine to-azure-radiance py-6 text-left text-xs text-eerie-black md:text-sm">
      <AppContainer>
        <div
          class="flex w-full flex-wrap items-center justify-between gap-6 text-center text-light-gray md:flex-nowrap md:gap-10 md:text-left">
          <div>
            © Powered by
            <a
              href="https://bitterbrains.com"
              target="_blank"
              class="font-semibold text-light-gray">
              BitterBrains Inc
            </a>
          </div>
        </div>
      </AppContainer>
    </div>
  </footer>
</template>
